import { forwardRef, useState } from 'react';
import EyeIcon from '../../../svgs/untitled-ui/eye.svg';
import { type BaseTextInputProps } from '../base-input/base-input.component';
import { TextInput } from '../text-input/text-input.component';

export type PasswordInputProps = Omit<BaseTextInputProps, 'type'> & {
	label: string;
	id: string;
};

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const togglePassword = (): void => {
		setIsPasswordVisible(!isPasswordVisible);
	};
	const inputType = isPasswordVisible ? 'text' : 'password';
	const iconTheme = isPasswordVisible ? 'theme-primary' : 'theme-grey';

	return (
		<TextInput
			icon={<EyeIcon className={`${iconTheme} f4`} data-testid="VisibilityIcon" />}
			iconOnClick={togglePassword}
			type={inputType}
			{...props}
			ref={ref}
		/>
	);
});
